import 'mutationobserver-shim'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import eventBus from '@/services/EventBus.js'
import store from './store'
// import VueFacebookPixel from 'vue-analytics-facebook-pixel'
// import VueAppInsights from 'vue-application-insights'
import mybeauty from './mixins/mybeauty'
import VueGtm from "vue-gtm"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

const app = createApp(App)

app.use(router)
app.use(store)
app.use(VueGtm, {
    id: 'GTM-PGQCV8F',
    defer: false,
    compatibility: false,
    enabled: true,
    debug: window.webpackHotUpdate,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false,
})
app.mixin(mybeauty)

// VueFacebookPixel and VueAppInsights are commented out as in your original

// Vue.config.productionTip and Vue.config.ignoredElements are not available in Vue 3
// To ignore custom elements in Vue 3, use config.isCustomElement in vue.config.js or pass to app.config

app.config.isCustomElement = tag => tag === 'g:savetoandroidpay'

app.mount('#app')

// Global event bus pattern is discouraged in Vue 3, but if you need to keep it:
window.googleCallback = function (message) {
    eventBus.$emit('googleDownloadRef', message)
}